import { render } from "./MainBanner.vue?vue&type=template&id=9e13e476&scoped=true"
import script from "./MainBanner.vue?vue&type=script&lang=js"
export * from "./MainBanner.vue?vue&type=script&lang=js"

import "./MainBanner.vue?vue&type=style&index=0&id=9e13e476&lang=scss&scoped=true"

import exportComponent from "/home/duanpengyuan/Projects/dcp-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e13e476"]])

export default __exports__